import React from 'react';
import { Route } from 'react-router-dom';
import { routes } from 'shared/constants/routes';
import Login from './containers/Login';

export default () => <Route path={routes.auth.login.path} key="auth-login" component={Login} exact />;
